import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

const CRISP_WEBSITE_ID = '3d7257b3-d2aa-4fd3-bd8a-eea7162b5021';
const CRISP_STYLE_ID = 'crisp-position-overrides';

export function CrispChat() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Configure Crisp BEFORE loading the script so the launcher renders with
      // our preferred glyph instead of the default speech bubble.
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
      // Use the "question_mark" preset — clearer "support / help" affordance.
      // Other available glyphs: "chat", "lightbulb", "lifebuoy", "heart", "wave", "wink".
      (window.$crisp as unknown[]).push(['config', 'chat:icon', ['question_mark']] as never);

      const script = document.createElement('script');
      script.src = 'https://client.crisp.chat/l.js';
      script.async = true;
      script.id = 'crisp-script';
      document.head.appendChild(script);

      // Lift the launcher above the global audio player (80px tall, fixed
      // bottom). Without this it sits on top of the playback controls.
      if (!document.getElementById(CRISP_STYLE_ID)) {
        const style = document.createElement('style');
        style.id = CRISP_STYLE_ID;
        style.textContent = `
          .crisp-client .cc-1brb6 .cc-1yy0g .cc-1no03,
          .crisp-client .cc-1brb6 .cc-1yy0g,
          .crisp-client .cc-kv6t {
            bottom: 96px !important;
            right: 24px !important;
            z-index: 60 !important;
          }
          @media (max-width: 640px) {
            .crisp-client .cc-1brb6 .cc-1yy0g .cc-1no03,
            .crisp-client .cc-1brb6 .cc-1yy0g,
            .crisp-client .cc-kv6t {
              bottom: 88px !important;
              right: 16px !important;
            }
          }
        `;
        document.head.appendChild(style);
      }

      return () => {
        // Cleanup on logout or unmount
        const el = document.getElementById('crisp-script');
        if (el) el.remove();
        const styleEl = document.getElementById(CRISP_STYLE_ID);
        if (styleEl) styleEl.remove();
        delete window.$crisp;
        delete window.CRISP_WEBSITE_ID;
        // Remove Crisp injected elements
        document.querySelectorAll('[id^="crisp-"]').forEach(e => e.remove());
        document.querySelectorAll('.crisp-client').forEach(e => e.remove());
      };
    }
  }, [user]);

  return null;
}
